import { useState } from 'react'
import { Box, IconButton } from '@mui/material'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { BenchmarkStatusReason } from '@cibo/core'
import { BenchmarkStatusReasons } from '..'
import { ResponsiveDialog } from '@cibo/ui'

export const ReasonsPopper = ({
  reasons,
  Icon,
}: {
  reasons: BenchmarkStatusReason[]
  Icon: any
}) => {
  const [open, setOpen] = useState(false)

  const IconComponent = Icon || HelpOutlineOutlinedIcon

  return (
    <>
      <IconButton onClick={() => setOpen(!open)} disabled={!reasons?.length}>
        <IconComponent />
      </IconButton>

      <ResponsiveDialog open={open} onClose={() => setOpen(false)}>
        <Box p={1}>
          <BenchmarkStatusReasons reasons={reasons} />
        </Box>
      </ResponsiveDialog>
    </>
  )
}
